import type { GettingStartedStep, GettingStartedSubtaskType } from '@core/getting-started-types';
import { GettingStartedSubtask } from '@core/getting-started-types';

import { gettingStartedConfiguration } from './types';

export const orderedSubtasks: GettingStartedSubtask[] = gettingStartedConfiguration.flatMap(
  ({ subtasks }) => subtasks,
);

export const firstUnfinishedSubtask = (
  subtasks: Record<GettingStartedSubtask, boolean>,
): GettingStartedSubtask | null =>
  getAvailableOrderedSubtasks(orderedSubtasks, subtasks).find(subtask => !subtasks[subtask]) ||
  null;

export const nextUnfinishedSubtask = (
  subtasks: Record<GettingStartedSubtask, boolean>,
  subtaskInProgress: GettingStartedSubtask | null,
): GettingStartedSubtask | null => {
  if (!subtaskInProgress) return firstUnfinishedSubtask(subtasks);

  const availableOrderedSubtasks = getAvailableOrderedSubtasks(orderedSubtasks, subtasks);

  const subtaskIndex = availableOrderedSubtasks.indexOf(subtaskInProgress);
  return (
    availableOrderedSubtasks.slice(subtaskIndex).find(subtask => !subtasks[subtask]) ||
    firstUnfinishedSubtask(subtasks)
  );
};

export const findStepForSubtask = (subtask: GettingStartedSubtask): GettingStartedStep | null =>
  subtask ? gettingStartedConfiguration.find(item => item.subtasks.includes(subtask))!.step : null;

export const getAvailableSubtasksVisitedState = (
  subtasks: GettingStartedSubtask[],
  data: GettingStartedSubtaskType,
): Partial<GettingStartedSubtaskType> | {} => {
  if (!data) return {};

  return subtasks.reduce(
    (acc, subtask) => (data[subtask] !== undefined ? { ...acc, [subtask]: data[subtask] } : acc),
    {},
  );
};

export const getAvailableOrderedSubtasks = (
  orderedSubtasks: GettingStartedSubtask[],
  availableSubtask: Record<GettingStartedSubtask, boolean>,
) =>
  orderedSubtasks.reduce(
    (acc, subtask) => (availableSubtask[subtask] !== undefined ? [...acc, subtask] : acc),
    [],
  );

export const checkIfDrawerNextStepException = (
  activeSubtask: GettingStartedSubtask | null,
): boolean => {
  const exceptionSubtask = [
    GettingStartedSubtask.SetUpRoles,
    GettingStartedSubtask.AdjustNotifications,
  ];

  if (!activeSubtask) return false;

  return exceptionSubtask.includes(activeSubtask);
};
